module.exports = __webpack_public_path__ + "static/media/bg3.31a8c3dd.jpg";